import type { CalendarType } from "@/constants/Calendar";
import { CalendarTypeDefinitions } from "@/constants/Calendar";
import { ConfirmationAlertTestID } from "@/constants/TestID";
import ConfirmationAlert from "@/ui/composed/alerts/ConfirmationAlert";
import { FAIconName } from "@/ui/core";

interface DisableCalendarSyncConfirmationAlertProps {
  calendarType: CalendarType;
  isOpen: boolean;
  onConfirm: () => void;
  onDismiss: () => void;
}

const DisableCalendarSyncConfirmationAlert = ({
  calendarType,
  isOpen,
  onConfirm,
  onDismiss,
}: DisableCalendarSyncConfirmationAlertProps) => {
  const { name } = CalendarTypeDefinitions[calendarType];
  const title = "Disconnect calendar?";
  const message = `Your Equip events will no longer sync to your ${name}. You can turn this back on anytime.`;

  return (
    <ConfirmationAlert
      confirmationType="destructive"
      confirmLeftIcon={FAIconName.CalendarXmark}
      confirmText="Disconnect calendar"
      isOpen={isOpen}
      message={message}
      onConfirm={onConfirm}
      onDismiss={onDismiss}
      testID={ConfirmationAlertTestID.Primary}
      title={title}
    />
  );
};

export default DisableCalendarSyncConfirmationAlert;
export type { DisableCalendarSyncConfirmationAlertProps };
